import React, { useState, forwardRef } from "react";
import { CustomButton } from './../../components';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useDispatch } from 'react-redux';
import { setError } from "../../redux/states/error";
import { Alert, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Snackbar, TextField } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { onboardingTarjetasApi } from '../../api/onboardingTarjetas';
import { createUser } from '../../redux/states/user';
import { setProduct } from "../../redux/states/product";
import { useNavigate } from 'react-router-dom';
import { PrivateRoutes, PublicRoutes } from '../../routes';
import { Loading } from '../../components';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Message } from '@mui/icons-material';
import { InputPersonalizadoTelefonoAnimacion } from "../../components/InputPersonalizado";

interface infoSnack {
  open: boolean;
  message: string;
}

const infoSnackDafault = {
  open: false,
  message: ''
}

interface Cliente {
  apellido: string;
  cuit: string;
  nombre: string;
}

interface DatosRespuesta {
  resultado: boolean;
  errores: {
    idError: string;
    descripcion: string;
  },
  datos: {
    idtramite: string;
    clientes: Cliente[];
  };
}

interface Errores {
  idError: string;
  mensaje: string;
}

interface ErroresCelular {
  animacion: string;
  mensaje: string;
}


const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: {
    xs: 300,
    sm: 400,
    md: 500
  },
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: 5,
  boxShadow: 24,
  p: 4,
};

const styleError = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center',
  width: {
    xs: 250,
    sm: 300,
    md: 500
  },
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: 5,
  boxShadow: 24,
  p: 4,
};

const textReenvioStyle = {
  backgroundColor: "#E4FFFA",
  padding: "2px",
  marginTop: 5,
  width: {
    xs: "20rem",
    md: "35vw"
  },
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.501)'
}

const voidCliente = {
  apellido: "",
  cuit: "",
  nombre: ""
}

interface SnackState {
  open: boolean;
  message: string;
}

const voidDatosRespuesta = {
  resultado: false,
  errores: {
    idError: "",
    descripcion: ""
  },
  datos: {
    idtramite: "",
    clientes: [voidCliente],
  }
}

const voidErrores = {
  idError: "-1",
  mensaje: ""
}

const voidErroresCelular = {
  animacion: "0",
  mensaje: ""
}

function formatearCUIL(cuil: string): string {
  const prefijo = cuil.substring(0, 2);
  let dni = cuil.substring(2, cuil.length - 1);
  const verificador = cuil.substring(cuil.length, cuil.length - 1);

  return `${prefijo}-${dni}-${verificador}`;
}

const ConfirmarUsuario = forwardRef<HTMLDivElement, { idtramite: string, cliente: Cliente, dnn: string, celular: string, onCloseModal: (value: boolean) => void, onError: (err: Errores) => void, onCloseModalConfirmationsms: (value: boolean) => void, onOpenLoading: (value: boolean) => void }>(({ idtramite, cliente, dnn, celular, onCloseModal, onError, onCloseModalConfirmationsms, onOpenLoading }, ref) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleCloseModal = async () => {
    onCloseModal(false);
  }

  const seleccionSolicitante = () => {
    
    onOpenLoading(true);
    console.log(`cliente: ${cliente.cuit} idtramite: ${idtramite}`)

    onboardingTarjetasApi
      .cuitSeleccionado(idtramite, cliente.cuit)
      .then((resp) => {
        if (resp.status === 200) {
          console.log(`SeleccionarSolicitante: ${JSON.stringify(resp.data)}`);
          onOpenLoading(false);
          if (resp.data.resultado) {
            if(resp.data.datos.validaTokenSMS) {
              onCloseModalConfirmationsms(true);
            } else {
              onCloseModal(false);
              navigate(`/${PrivateRoutes.PRIVATE}/${PrivateRoutes.TARJETAS}`, {
                replace: true,
              });
            }
          } else {
            dispatch(
              setError({
                idError: resp.data.errores.idError,
                mensaje: resp.data.errores.mensaje,
              })
            );
            onError({
              idError: resp.data.errores.idError,
              mensaje: `Hubo un error al seleccionar al solicitante.`,
            });
            // setTimeout(() => {
            //   navigate(`/${PublicRoutes.ERROR}`, { replace: true });
            // }, 2000);
          }
        } else {
          dispatch(
            setError({
              idError: resp.data.errores.idError,
              mensaje: resp.data.errores.mensaje,
            })
          );
          onError({
            idError: resp.data.errores.idError,
            mensaje: `Hubo un error al seleccionar al solicitante.`,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          // La API respondió con un código de estado HTTP
          const statusCode = error.response.status;
          const statusMessage = error.response.statusText;

          console.error("Error Status Code:", statusCode);
          console.error("Error Status Message:", statusMessage);
          dispatch(
            setError({
              idError: statusCode,
              mensaje: statusMessage,
            })
          );
          onError({
            idError: statusCode.toString(),
            mensaje: `Hubo un error al seleccionar al solicitante."}`,
          });
        } else if (error.request) {
          // No se recibió respuesta del servidor
          console.error("Error al realizar la solicitud:", error.request);
          dispatch(
            setError({
              idError: "54",
              mensaje: error.request,
            })
          );
          onError({
            idError: "54",
            mensaje: "Error al realizar la solicitud.",
          });
        } else {
          // Error al configurar la solicitud
          console.error("Error al realizar la solicitud:", error.message);
          dispatch(
            setError({
              idError: "54",
              mensaje: error.message,
            })
          );
          onError({
            idError: "54",
            mensaje: `Error al realizar la solicitud.`,
          });
        }
      })
      .finally(() => {
        onOpenLoading(false);
      });
  }

  return (
    <Box sx={style} ref={ref}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Typography component="p" textAlign={"center"}>
            ¿Es usted <Typography component="strong" fontWeight="bold" >{cliente.apellido}, {cliente.nombre}</Typography> <br />
            con número de cuil: <strong>{formatearCUIL(cliente.cuit)}</strong>?
          </Typography>
        </Grid>
        <Grid item xs={12} textAlign={"center"} >
          <Button variant="contained" sx={{ marginRight: "15px" }} color="secondary" onClick={handleCloseModal}>No, no soy yo</Button>
          <Button variant="contained" sx={{ marginLeft: "15px" }} onClick={seleccionSolicitante}>Soy yo</Button>
        </Grid>

      </Grid>
    </Box>
  );
});

const ModalUsers = forwardRef<HTMLDivElement, { clientes: Cliente[], idtramite: string, dnn: string, celular: string, onSelectCliente: (cliente: Cliente) => void, onCloseModalConfirmationsms: (value: boolean) => void, onCloseModal: (value: boolean) => void, onError: (value: Errores) => void, onOpenLoading: (value: boolean) => void }>(({ clientes, idtramite, dnn, celular, onSelectCliente, onCloseModalConfirmationsms, onCloseModal, onError, onOpenLoading }, ref) => {

  const [isDisabled, setIsDisable] = React.useState(true);
  const [clienteSeleccionado, setClienteSeleccionado] = React.useState<Cliente | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCloseModal = async () => {
    onCloseModal(false);
  }


  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const clienteSeleccionado = clientes.find(cliente => cliente.cuit === event.target.value);

    if (clienteSeleccionado) {
      setIsDisable(false);
      setClienteSeleccionado(clienteSeleccionado);
    }
  };

  const selectClient = () => {

    if (clienteSeleccionado) {

      onOpenLoading(true);
      onSelectCliente(clienteSeleccionado);

      console.log(`cliente seleccionado: ${clienteSeleccionado.cuit}, idtramite: ${idtramite}`);

      onboardingTarjetasApi
        .cuitSeleccionado(idtramite, clienteSeleccionado.cuit)
        .then((resp) => {
          if (resp.status === 200) {
            console.log(`SeleccionarSolicitante: ${JSON.stringify(resp.data)}`);
            onOpenLoading(false);
            if (resp.data.resultado) {
              dispatch(createUser({
                idTramite: idtramite,
                name: resp.data.datos.clientes[0].nombre,
                surname: resp.data.datos.clientes[0].apellido,
                cuit: resp.data.datos.clientes[0].cuit,
                dnn: dnn,
                telefono: celular
              }));
              
              if(resp.data.datos.validaTokenSMS) {
                onCloseModalConfirmationsms(true);
              } else {
                onCloseModal(false);
                navigate(`/${PrivateRoutes.PRIVATE}/${PrivateRoutes.TARJETAS}`, {
                  replace: true,
                });
              }
            } else {
              onError({ idError: '56', mensaje: `Hubo un error al seleccionar al solicitante.` });
            }
          } else {
            onError({ idError: '57', mensaje: "Hubo un error al seleccionar al solicitante." });
          }
        });


    }
  }

  return (
    <Box sx={style} ref={ref}>
      <Grid container>
        <Grid item xs={12}>
          <FormControl>
            <Grid container>
              <Grid item xs={12}>
                <FormLabel id="personaIdentificar">Quién es usted?</FormLabel>
              </Grid>
              <Grid item xs={12}>
                <RadioGroup
                  aria-labelledby="personaIdentificar"
                  name="radio-buttons-group"
                  onChange={handleRadioChange}
                >

                  {clientes.map((cliente, index) => (
                    <FormControlLabel key={index} value={cliente.cuit} control={<Radio />} label={`${cliente.cuit} - ${cliente.nombre} ${cliente.apellido}`} />
                  ))}

                </RadioGroup>
              </Grid>
              <Grid container justifyContent="center" spacing={2}>
                <Grid
                  item
                  display="flex"
                  justifyContent="center"
                  gap={2}
                >
                  <Button variant="contained" sx={{ marginRight: "15px" }} color="secondary" onClick={handleCloseModal}>
                    Regresar
                  </Button>
                  <Button variant="contained" color="primary" onClick={selectClient}>
                    Enviar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
});

const ModalConfirmation = forwardRef<HTMLDivElement, { idtramite: string, cliente: Cliente, dnn: string, celular: string, onCloseModal: (value: boolean) => void, onError: (value: Errores) => void, onCloseModalConfirmationsms: (value: boolean) => void, onOpenLoading: (value: boolean) => void, onStateSnack: (value: SnackState) => void }>(({ idtramite, cliente, dnn, celular, onCloseModal, onError, onCloseModalConfirmationsms, onOpenLoading, onStateSnack }, ref) => {

  const [tokenIngresado, setToken] = React.useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCloseModal = async () => {
    onCloseModal(false);
  }

  const handleToken = (event: React.ChangeEvent<HTMLInputElement>) => {
    setToken(event.target.value);
  };

  function validarToken() {
    onOpenLoading(true);

    onboardingTarjetasApi
      .confirmarToken(tokenIngresado, idtramite)
      .then((resp) => {
        console.log(`token: ${tokenIngresado}, idTramite ${idtramite}`);
        console.log(`validarToken: ${JSON.stringify(resp.data)}`);

        if (resp.status === 200) {
          if (resp.data.resultado) {
            navigate(`/${PrivateRoutes.PRIVATE}/${PrivateRoutes.TARJETAS}`, {
              replace: true,
            });
            console.log("mensaje validado");
          } else {
            let mensajeError = "Hubo un error al validar el token. Por favor, intentá nuevamente."; // Mensaje por defecto

            switch (resp.data.errores.idError) {
              case 13:
                mensajeError = "Ocurrió un error al validar el token. por favor volvé a intentar.";
                break;
              case 8:
                //El código ya fue validado anteriormente.
                onError({
                  idError: resp.data.errores.idError,
                  mensaje: `Hubo un error en el proceso de solicitud. Por favor, intentá nuevamente.`
                });
                break;
              case 16:
                mensajeError = `El código se encuentra vencido. Hacé click en el botón "AQUÍ" para recibir un código nuevo.`;
                break;
              case 17:
                mensajeError = `Se ha excedido la cantidad máxima de intentos. Hacé click en el botón "AQUÍ" para recibir un código nuevo.`;
                break;
              case 18:
                mensajeError = "El código ingresado no coincide. Intentá nuevamente";
                break;
              case 19:
                //No se encontró ningún token asociado al ID de transacción.
                onError({
                  idError: resp.data.errores.idError,
                  mensaje: `Hubo un error en el proceso de solicitud. Por favor, intentá nuevamente.`
                });
                break;
            }
            onStateSnack({
              open: true,
              message: mensajeError,
            });
          }
        } else {
          onStateSnack({
            open: true,
            message: "Hubo un error al validar el token. Intentá nuevamente.",
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          console.error("Error Status Code:", error.response.status);
          console.error("Error Status Message:", error.response.statusText);
          onStateSnack({
            open: true,
            message: "Hubo un error al validar el token. Intentá nuevamente.",
          });
        } else if (error.request) {
          console.error("No response from server:", error.request);
          onStateSnack({
            open: true,
            message: "Hubo un error al validar el token. Intentá nuevamente.",
          });
        } else {
          console.error("Error setting up the request:", error.message);
          onStateSnack({
            open: true,
            message: "Hubo un error al validar el token. Intentá nuevamente.",
          });
        }
      })
      .finally(() => {
        onOpenLoading(false);
      });
  }


  function reenviarMensaje() {
    onOpenLoading(true);
    console.log(`cliente: ${cliente.cuit} idtramite: ${idtramite}`);

    onboardingTarjetasApi
      .reEnviarToken(idtramite, dnn + celular)
      .then((resp) => {
        if (resp.status === 200) {
          onOpenLoading(false);
          if (resp.data.resultado) {
            onCloseModalConfirmationsms(true);
          } else {
            dispatch(
              setError({
                idError: resp.data.errores.idError,
                mensaje: resp.data.errores.mensaje,
              })
            );
            onError({
              idError: resp.data.errores.idError,
              mensaje: `Hubo un error al reenviar el token.`,
            });
            // setTimeout(() => {
            //   navigate(`/${PublicRoutes.ERROR}`, { replace: true });
            // }, 2000);
          }
        } else {
          dispatch(
            setError({
              idError: resp.data.errores.idError,
              mensaje: resp.data.errores.mensaje,
            })
          );
          onError({
            idError: resp.data.errores.idError,
            mensaje: `Hubo un error al reenviar el token.`,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          // La API respondió con un código de estado HTTP
          const statusCode = error.response.status;
          const statusMessage = error.response.statusText;

          console.error("Error Status Code:", statusCode);
          console.error("Error Status Message:", statusMessage);
          dispatch(
            setError({
              idError: statusCode.toString(),
              mensaje: statusMessage,
            })
          );
          onError({
            idError: statusCode.toString(),
            mensaje: `Hubo un error al reenviar el token."}`,
          });
        } else if (error.request) {
          // No se recibió respuesta del servidor
          console.error("No response from server:", error.request);
          dispatch(
            setError({
              idError: "54",
              mensaje: "No se recibió respuesta del servidor",
            })
          );
          onError({
            idError: "54",
            mensaje: "Hubo un error al reenviar el token.",
          });
        } else {
          // Error al configurar la solicitud
          console.error("Error setting up the request:", error.message);
          dispatch(
            setError({
              idError: "54",
              mensaje: error.message,
            })
          );
          onError({
            idError: "54",
            mensaje: `Hubo un error al reenviar el token.`,
          });
        }
      })
      .finally(() => {
        onOpenLoading(false);
      });
  }

  return (

    <Box sx={style} ref={ref}>
      <Typography id="modal-modal-title" variant="h6" component="h2" textAlign={"center"}>
        Validación del celular
      </Typography>

      <div style={{ textAlign: "center", marginBottom: "15px", marginTop: "15px" }}>
        <TextField
          fullWidth label="Ingrese el codigo recibido"
          id="codigoVerificacion"
          sx={{
            '& .MuiInputBase-input::placeholder': {
              fontSize: "3px"
            },
          }}
          onChange={handleToken} />
      </div >

      <Grid
        item
        sx={{ marginBottom: { xs: 5, md: 10 } }}
        xs={12}
        justifyContent="center"
        alignItems="center"
        mb={10}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box sx={textReenvioStyle}>
            <Typography
              sx={{
                fontSize: { xs: "0.6rem", md: "1.0rem" },
                padding: { xs: 1, md: 2 },
              }}
            >
              ¿No recibiste el código? Por favor, reintentá enviarlo presionando{" "}
              <span
                style={{ color: "#ff1744", fontWeight: "bold", cursor: "pointer" }}
                onClick={reenviarMensaje}
              >
                AQUÍ
              </span>
            </Typography>
          </Box>
        </Box>
      </Grid>

      <Grid container justifyContent="center" spacing={2}>
        <Grid
          item
          display="flex"
          justifyContent="center"
          gap={2} // Espaciado entre botones
        >
          <Button variant="contained" sx={{ marginRight: "15px" }} color="secondary" onClick={handleCloseModal}>
            Regresar
          </Button>
          <Button variant="contained" sx={{ marginLeft: "15px" }} onClick={validarToken}>
            Validar
          </Button>
        </Grid>
      </Grid>

    </Box>
  );
});

const ModalError = forwardRef<HTMLDivElement, { error: Errores; onCloseModal: (value: boolean) => void }>(({ error, onCloseModal }, ref) => {

  const handleCloseModal = async () => {
    onCloseModal(false);
  }

  return (
    <Box sx={{ ...styleError, position: 'relative' }} ref={ref}>
      <IconButton
        aria-label="close"
        onClick={handleCloseModal}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      <ErrorOutlineIcon color="error" sx={{ fontSize: 40 }} />
      <Typography id="modal-modal-description" sx={{ mt: 1 }}>
        {error.mensaje}
      </Typography>

      <Typography sx={{ mt: 0 }} fontWeight="bold">
        Por favor, intentá nuevamente.
      </Typography>

    </Box>
  );
});

const ModalErrorCelular = forwardRef<HTMLDivElement, { onCloseModal: (value: boolean) => void }>(({ onCloseModal }, ref) => {
  const handleCloseModal = async () => {
    onCloseModal(false);
  }

  return (
    <Box sx={{ ...styleError, position: 'relative' }} ref={ref}>
      <IconButton
        aria-label="close"
        onClick={handleCloseModal}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      <Typography id="modal-modal-description" sx={{ mt: 1 }} fontWeight="bold">
        Revisá tu número de celular.
      </Typography>
      <Typography id="modal-modal-description" sx={{ mt: 1 }}>
        Recordá no repetir el código de área.
      </Typography>

      <InputPersonalizadoTelefonoAnimacion />

      <Typography sx={{ mt: 3 }} fontWeight="bold">
        Por favor, intentá nuevamente.
      </Typography>

      <Button variant="contained" sx={{ mt: 3 }} color="secondary" onClick={handleCloseModal}>
        Reintentar
      </Button>

    </Box>
  );
});

export default function BasicModal({
  dni,
  dnn,
  celular,
  producto,
  codigoReferido,
  esBCSAWEB,
  monto,
  utmParams,
  onStateSnack,
  setCelular,
  checked,
  captchaIsDone,
  isVisaChecked,
  isMasterChecked,
  tarjetas,
}: {
  dni: string;
  dnn: string;
  celular: string;
  producto: number;
  codigoReferido: string;
  esBCSAWEB: string;
  monto: number;
  utmParams : Record<string, string>;
  onStateSnack: (value: SnackState) => void;
  setCelular: (value: string) => void;
  checked: boolean;
  captchaIsDone: boolean;
  isVisaChecked: boolean;
  isMasterChecked: boolean;
  tarjetas: number;
}) {
  const [open, setOpen] = useState(false);
  const [datosRespuesta, setDatosRespuesta] = useState<DatosRespuesta>(voidDatosRespuesta);
  const [cliente, setCliente] = useState<Cliente>(voidCliente);
  const [loadingRespuesta, setLoadingRespuesta] = useState(false);
  const [errorRespuesta, setErrorRespuesta] = useState<Errores>(voidErrores);
  const [openVerificacionCel, setOpenVerificacionCel] = useState(false);
  const [openErrorCel, setOpenErrorCel] = useState(false);
  const [doblePersona, setdoblePersona] = useState(false);

  // --- Estado para aviso ---
  const [openAviso, setOpenAviso] = useState(false);
  const [mensajeAviso, setMensajeAviso] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  dispatch(setProduct(producto));

  const handleOpen = () => {
    let mensaje = "";
    if (!dni) {
      mensaje = "Por favor, completá tu documento.";
    } else if (!dnn) {
      mensaje = "Por favor, completá el código de área de tu teléfono.";
    } else if (!celular) {
      mensaje = "Por favor, completá tu teléfono.";
    } else if (!checked) {
      mensaje = "Por favor, aceptá los Términos y Condiciones.";
    } else if (!captchaIsDone) {
      mensaje = "Por favor, validá el captcha.";
    } else if (tarjetas === 3 && !isVisaChecked && !isMasterChecked) {
      mensaje = "Por favor, seleccioná una tarjeta.";
    }

    if (mensaje) {
      onStateSnack({
        open: true,
        message: mensaje,
      });
      return;
    }

    setLoadingRespuesta(true);
    setOpen(true);
    iniciarTramite();
  };

  const handleCloseAviso = () => setOpenAviso(false);

  const handleClose = () => {
    setOpen(false);
  };

  const iniciarTramite = () => {
    setErrorRespuesta(voidErrores);
    setDatosRespuesta(voidDatosRespuesta);
    setCliente(voidCliente);
    setOpenVerificacionCel(false);

    // Validación de celular
    let dnnModificado = dnn.startsWith("0") ? dnn : "0" + dnn;
    const numeroCompleto = dnnModificado + celular;

    if (numeroCompleto.length <= 10) {
      setLoadingRespuesta(false);
      setCelular("");
      setOpenErrorCel(true);
      return;
    }

    if (numeroCompleto.length >= 12 && numeroCompleto.length !== 13) {
      setLoadingRespuesta(false);
      setCelular("");
      setOpenErrorCel(true);
      return;
    }

    if (numeroCompleto.length === 13) {
      if (!celular.startsWith("15")) {
        setLoadingRespuesta(false);
        setCelular("");
        setOpenErrorCel(true);
        return;
      }
    }

    onboardingTarjetasApi.iniciarTramite(dni, dnnModificado, celular, producto, codigoReferido, esBCSAWEB, monto, utmParams)
      .then((response) => {
        console.log(`Datos para iniciar trámite: DNI: ${dni}, dnn: ${dnnModificado}, celular: ${celular}, producto: ${producto}, codigoReferido: ${codigoReferido}`);
        console.log(`Response iniciar Tramite: ${JSON.stringify(response.data.datos)}`);

        if (response.data.resultado) {
          console.log(response.data);

          setDatosRespuesta(response.data);
          setdoblePersona(response.data.datos.clientes.length >= 2);

          if (response.data.datos.clientes.length == 1) {
            setCliente(response.data.datos.clientes[0]);
            dispatch(createUser({
              idTramite: response.data.datos.idtramite,
              name: response.data.datos.clientes[0].nombre,
              surname: response.data.datos.clientes[0].apellido,
              cuit: response.data.datos.clientes[0].cuit,
              dnn: dnnModificado,
              telefono: celular
            }));
          }
        } else if (response && response.data.errores) {
          console.log(response.data);
          setDatosRespuesta(response.data);
          setErrorRespuesta(response.data.errores);

          if (response.data.errores.idError == "01") {
            dispatch(createUser({
              idTramite: response.data.datos.idtramite,
              name: "",
              surname: "",
              cuit: "",
              dnn: dnnModificado,
              telefono: celular
            }));
          }

          if (response.data.errores.idError == 25) {
            navigate(`/${PublicRoutes.ERROR}`, { replace: true });
          }
        } else {
          setErrorRespuesta({
            idError: "50",
            mensaje: "Hubo un error al iniciar el trámite."
          });
        }
      }).catch((error) => {
        if (error.response) {
          const statusCode = error.response.status;
          const statusMessage = error.response.statusText;

          console.error("Error Status Code:", statusCode);
          console.error("Error Status Message:", statusMessage);

          setErrorRespuesta({
            idError: "51",
            mensaje: "Hubo un error al iniciar el trámite."
          });

        } else if (error.request) {
          console.error("No response from server:", error.request);
          setErrorRespuesta({
            idError: "51",
            mensaje: "Hubo un error al iniciar el trámite."
          });
        } else {
          console.error("Error setting up the request:", error.message);
          setErrorRespuesta({
            idError: "51",
            mensaje: "Hubo un error al iniciar el trámite."
          });
        }
      })
      .finally(() => {
        setLoadingRespuesta(false);
      });
  };

  const MostrarInfoModal = forwardRef<HTMLDivElement>(() => {
    if (!loadingRespuesta) {
      if (errorRespuesta.idError != "-1")
        return <ModalError error={errorRespuesta} onCloseModal={setOpen} />;

      if (openErrorCel)
        return <ModalErrorCelular onCloseModal={setOpen} />;

      if (cliente.cuit != "" && !openVerificacionCel)
        return (
          <ConfirmarUsuario
            idtramite={datosRespuesta.datos.idtramite}
            cliente={cliente}
            dnn={dnn}
            celular={celular}
            onCloseModal={setOpen}
            onError={setErrorRespuesta}
            onCloseModalConfirmationsms={setOpenVerificacionCel}
            onOpenLoading={setLoadingRespuesta}
          />
        );

      if (openVerificacionCel)
        return (
          <ModalConfirmation
            idtramite={datosRespuesta.datos.idtramite}
            cliente={cliente}
            dnn={dnn}
            celular={celular}
            onCloseModal={setOpen}
            onError={setErrorRespuesta}
            onCloseModalConfirmationsms={setOpenVerificacionCel}
            onOpenLoading={setLoadingRespuesta}
            onStateSnack={onStateSnack}
          />
        );

      if (doblePersona && !openVerificacionCel)
        return (
          <ModalUsers
            idtramite={datosRespuesta.datos.idtramite}
            clientes={datosRespuesta.datos.clientes}
            dnn={dnn}
            celular={celular}
            onSelectCliente={(cliente) => setCliente(cliente)}
            onCloseModal={setOpen}
            onError={setErrorRespuesta}
            onCloseModalConfirmationsms={setOpenVerificacionCel}
            onOpenLoading={setLoadingRespuesta}
          />
        );
    } else {
      return <Loading openLM={false} messageLM={"Cargando"} />;
    }
  });

  return (
    <div>
      <CustomButton text="Ver oferta" onClick={handleOpen} />
      <Modal
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MostrarInfoModal />
      </Modal>
      {/* Snackbar para avisos */}
      <Snackbar
        open={openAviso}
        autoHideDuration={4000}
        onClose={handleCloseAviso}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseAviso} severity="warning" variant="filled">
          {mensajeAviso}
        </Alert>
      </Snackbar>
    </div>
  );
}

